import { render, staticRenderFns } from "./userNews.vue?vue&type=template&id=5b01408b&scoped=true"
import script from "./userNews.vue?vue&type=script&lang=js"
export * from "./userNews.vue?vue&type=script&lang=js"
import style0 from "./userNews.vue?vue&type=style&index=0&id=5b01408b&prod&lang=scss"
import style1 from "./userNews.vue?vue&type=style&index=1&id=5b01408b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01408b",
  null
  
)

export default component.exports